// src/theme/index.js
import { extendTheme } from '@chakra-ui/react';
import { colors } from './foundations/colors';
import { typography } from './foundations/typography';

const theme = extendTheme({
  colors,
  ...typography,
  styles: {
    global: {
      // Remove any global styles that might conflict with component styles
      body: {
        bg: 'white',
        color: 'gray.800'
      }
    }
  },
  components: {
    Button: {
      baseStyle: {
        _hover: {
          transform: 'translateY(-2px)',
          transition: 'all 0.2s'
        }
      },
      variants: {
        primary: {
          bg: 'brand.orange.500',
          color: 'white',
          _hover: { bg: 'brand.orange.600' }
        },
        secondary: {
          bg: 'transparent',
          border: '1px solid',
          borderColor: 'brand.blue.500',
          color: 'brand.blue.500',
          _hover: { bg: 'brand.blue.50' }
        }
      }
    }
  }
});

export default theme;